import React__default, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PT from 'prop-types';

// copied from packages/storm-ui/src/Portal/Portal.tsx
function useGetPortal(portalElementId) {
  /** All react hooks must be called in the same order every render */
  const portalRef = useRef(null);

  /** Prevent executing in none browser environment's */
  if (typeof document !== undefined) {
    if (portalElementId) {
      /** Get the portal element id from the function argument or theme */
      const portalElement = document.getElementById(portalElementId);
      /** If the portal element exists assign it to the ref */
      if (portalElement) {
        portalRef.current = portalElement;
        return portalRef;
      }
    }
  }

  /** When all options have been exhausted, give up and return undefined */
  return undefined;
}
const NodeSafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */
const Portal = ({
  children,
  portalElementId
}) => {
  /** Get the current portal ref */
  const portalRef = useGetPortal(portalElementId);

  /**
   * The `portalMounted` and `useEffect()` prevents react from attempting to use the portal
   * before it has been committed to the DOM. The `portalRef.current` will sometimes be `null` \
   * until after the initial render.
   */
  const [portalMounted, setPortalMounted] = useState(!!(portalRef !== null && portalRef !== void 0 && portalRef.current));
  useEffect(() => {
    setPortalMounted(true);
  }, []);

  // Skip using Portal when disabled or `portalRef` is not defined
  if (!portalRef) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }

  // When portalRef.current becomes available is it as the portal
  if (portalMounted && portalRef.current instanceof NodeSafeHTMLElement) {
    return /*#__PURE__*/createPortal(children, portalRef.current);
  }

  // Do not render any children when the `portalRef.current` is null.
  return null;
};
Portal.propTypes = {
  /**
   * The children to render into the `Portal`.
   */
  children: PT.node.isRequired,
  /**
   * The Id of the element into which the `children` should be rendered.
   */
  portalElementId: PT.string
};
Portal.defaultProps = {
  portalElementId: undefined
};

export { Portal as P };
//# sourceMappingURL=Portal-H7Hzq_Pr.js.map
